import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function ClientNurs() {
  return (
    <section className="p-100">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              <span style={{ color: "#198463" }}>The Client</span> Had?
            </h2>
            <p>
              An idea to provide a solution that can minimize the human effort
              of researching the lowest prices by visiting stores separately.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-md-1"
          >
            <StaticImage
              src="../../../images/case-studies/save-win/tek_img_04.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={777}
              height={590}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientNurs;
